import React from 'react';
import Icon from '../../../components/AppIcon';

const MitigationStrategies = ({ strategies }) => {
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'critical': return 'bg-error/10 text-error border-error/20';
      case 'high': return 'bg-warning/10 text-warning border-warning/20';
      case 'medium': return 'bg-accent/10 text-accent-foreground border-accent/20';
      default: return 'bg-muted text-muted-foreground border-border';
    }
  };

  const getPriorityIcon = (priority) => {
    switch (priority) {
      case 'critical': return 'AlertOctagon';
      case 'high': return 'AlertTriangle';
      case 'medium': return 'AlertCircle';
      default: return 'Circle';
    }
  };

  return (
    <div className="bg-card rounded-xl border border-border p-6 md:p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center">
          <Icon name="Shield" size={20} color="var(--color-success)" />
        </div>
        <h2 className="text-xl md:text-2xl font-semibold text-foreground">Strategi Mitigasi</h2>
      </div>
      <div className="space-y-4">
        {strategies?.map((strategy, index) => (
          <div key={index} className="border border-border rounded-lg overflow-hidden hover:shadow-md transition-all duration-250">
            <div className="p-4 bg-muted/30">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                <div className="flex items-center gap-3">
                  <div className={`w-10 h-10 rounded-lg ${getPriorityColor(strategy?.priority)} flex items-center justify-center border`}>
                    <Icon name={getPriorityIcon(strategy?.priority)} size={20} />
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-foreground">{strategy?.title}</h3>
                    <span className={`text-xs font-medium px-2 py-1 rounded ${getPriorityColor(strategy?.priority)} border`}>
                      Prioritas: {strategy?.priority?.toUpperCase()}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-4 text-sm">
                  <div className="flex items-center gap-2">
                    <Icon name="Calendar" size={16} color="var(--color-muted-foreground)" />
                    <span className="text-muted-foreground">Timeline:</span>
                    <span className="font-medium text-foreground">{strategy?.timeline}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Icon name="DollarSign" size={16} color="var(--color-muted-foreground)" />
                    <span className="text-muted-foreground">Biaya:</span>
                    <span className="font-medium text-foreground data-text">{strategy?.cost}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-4 space-y-4">
              <div>
                <h4 className="text-sm font-semibold text-foreground mb-2">Deskripsi</h4>
                <p className="text-sm text-muted-foreground leading-relaxed">{strategy?.description}</p>
              </div>

              <div>
                <h4 className="text-sm font-semibold text-foreground mb-2">Langkah Implementasi</h4>
                <div className="space-y-2">
                  {strategy?.steps?.map((step, stepIndex) => (
                    <div key={stepIndex} className="flex items-start gap-3">
                      <div className="w-6 h-6 rounded-full bg-primary/10 text-primary flex items-center justify-center flex-shrink-0 text-xs font-bold mt-0.5">
                        {stepIndex + 1}
                      </div>
                      <p className="text-sm text-foreground">{step}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <h4 className="text-sm font-semibold text-foreground mb-2">Dampak yang Diharapkan</h4>
                  <div className="space-y-2">
                    {strategy?.expectedImpact?.map((impact, impactIndex) => (
                      <div key={impactIndex} className="flex items-start gap-2">
                        <Icon name="CheckCircle2" size={16} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
                        <p className="text-sm text-foreground">{impact}</p>
                      </div>
                    ))}
                  </div>
                </div>

                <div>
                  <h4 className="text-sm font-semibold text-foreground mb-2">KPI Pengukuran</h4>
                  <div className="space-y-2">
                    {strategy?.kpis?.map((kpi, kpiIndex) => (
                      <div key={kpiIndex} className="flex items-start gap-2">
                        <Icon name="Target" size={16} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
                        <p className="text-sm text-foreground">{kpi}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MitigationStrategies;